










import Vue from 'vue';
import VueTrix from 'vue-trix';
import Component from 'vue-class-component';

const EditorProps = Vue.extend({
  props: {
    value: {
      type: String,
    },
  },
});

@Component({
  components: {
    VueTrix,
  },
})
export default class Editor extends EditorProps {
  internalValue = '';

  created() {
    this.internalValue = this.value;
  }

  onUpdate(content: string) {
    this.$emit('input', content);
  }
}
